export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-swipe-action/index.js